import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=f492db4a&scoped=true&"
import script from "./Restaurant.vue?vue&type=script&lang=js&"
export * from "./Restaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f492db4a",
  null
  
)

export default component.exports